export default __webpack_public_path__ + "static/media/push-notification.71d2a203.svg";